<script>
    import { alertinfo } from '../store.js';
    import { onMount } from "svelte";
    onMount(() =>{
        setTimeout(function(){
            alertinfo.set(false)
        },1800);
    });
</script>
<div class="alert">
    {$alertinfo}
</div>
<style>
    .alert{
        z-index: 99;
        min-width: 5rem;
        height: 1.8rem;
        font-size: .75rem;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #222222;
        border-radius: .3rem;
        position: fixed;
        top: 40vh;
        left:38%;
        box-sizing: border-box;
        padding: 0 .3rem;
    }
</style>